import { snackbarsReducer as sharedSnackbarsReducer } from 'shared/reducers/snackbarsReducer'

import { GOOGLE_APIS_LOADED } from 'helpers/constants'

export function googleApiReducer(state = {}, action: any) {
  switch (action.type) {
    case GOOGLE_APIS_LOADED:
      return { ...state, googleApisLoaded: true }
    default:
      return state || {}
  }
}

// Without this no-unreachable rule will fail
const snackbarsReducer = sharedSnackbarsReducer

export { snackbarsReducer }
